import { ReactComponent as SVG } from 'Assets/loaders/loading.svg';

import './Loader.css';
export const Loader = () => {
    return (
        <div className="Loader">
            <SVG />
        </div>
    )
}